export default __webpack_public_path__ + "static/media/testing-mobile.7d2fe2a2.jpg";